import { render, staticRenderFns } from "./PhysicalProjectEdit.vue?vue&type=template&id=20b5efcc&scoped=true"
import script from "./PhysicalProjectEdit.vue?vue&type=script&lang=js"
export * from "./PhysicalProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./PhysicalProjectEdit.vue?vue&type=style&index=0&id=20b5efcc&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5efcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b5efcc')) {
      api.createRecord('20b5efcc', component.options)
    } else {
      api.reload('20b5efcc', component.options)
    }
    module.hot.accept("./PhysicalProjectEdit.vue?vue&type=template&id=20b5efcc&scoped=true", function () {
      api.rerender('20b5efcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/physicalProject/PhysicalProjectEdit.vue"
export default component.exports